export default __webpack_public_path__ + "static/media/RPG_4.fff29cd7.png";